(function(){
  class Accordion {
    constructor (el) {
      this.el = el;
      this.toggleButton = el.querySelector(".js-accordion__toggle");
      this.accordionBody = el.querySelector(".js-accordion__target");
      this.maxHeight = this.el.dataset.maxHeight || 500;

      this.toggleButton.addEventListener("click", e => {
        e.currentTarget.classList.toggle("is-active");

        if (e.currentTarget.classList.contains("is-active")) {
          this.accordionBody.style.maxHeight = `${ this.maxHeight }px`;
        } else {
          this.accordionBody.style.maxHeight = "0";
        }
      });
    }
  }

  window.addEventListener("DOMContentLoaded", () => {
    const els = document.querySelectorAll(".js-accordion");
    const accordionElements = Array.from(els).map(el => new Accordion(el));
  });
})();
